<template>
  <main-container>
    <a-card>
      <div class="pageTop">
        <div style="flex: 1;">
          <a-space size="middle">
            <a-button
              v-for="(val, key) in service.list"
              :key="key"
              :type="`${service.active == val.id ? 'primary' : ''}`"
              @click="
                service.active = val.id;
                getGoodsList();
              "
            >
              <span>{{ val.line_place }}</span>
            </a-button>
          </a-space>
        </div>
        <a-button type="primary" @click="dialog = true">添加物品</a-button>
      </div>
    </a-card>
    <a-card>
      <a-table :loading="loading" :columns="columns" :data-source="dataSource" :pagination="pagination">
        <template slot="operation" slot-scope="record">
          <a-button
            size="small"
            type="primary"
            style="margin-right: 10px;"
            @click="
              dialog = true;
              detail = record;
            "
            >编辑</a-button
          >
          <a-popconfirm title="确认删除这个物品分类？" ok-text="确定" cancel-text="取消" @confirm="del(record.id)">
            <a-button size="small" type="danger">删除</a-button>
          </a-popconfirm>
        </template>
      </a-table>
    </a-card>

    <!-- 添加/编辑物品弹窗 -->
    <EditModal
      :show="dialog"
      :detail="detail"
      :service_id="service.active"
      :options="service.list"
      @success="getGoodsList()"
      @close="dialog = false"
    />
  </main-container>
</template>

<script>
const columns = [
  { title: 'ID', dataIndex: 'id' },
  { title: '分类名称', dataIndex: 'goods_name' },
  { title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' } },
];
import Service from '@/api/service';

import EditModal from './editModal';

export default {
  name: 'serviveGoodsCate',
  components: {
    EditModal,
  },
  data() {
    return {
      columns,
      loading: true,
      dialog: false,
      detail: {},
      service: {
        list: [],
        active: '',
      },
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
      },
    };
  },
  created() {
    Service.getServiceList().then(res => {
      this.service = {
        list: res.data,
        active: res.data[0].id,
      };
      this.getGoodsList();
    });
  },
  methods: {
    //获取物流线路对应商品信息
    getGoodsList() {
      this.loading = true;
      Service.serviceGoodsList({
        page: this.pagination.current,
        page_limit: this.pagination.pageSize,
        service_id: this.service.active,
      })
        .then(({ data }) => {
          this.pagination = {
            total: data.total_items,
            current: data.page,
            pageSize: data.page_limit,
          };
          this.dataSource = data.list;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    del(id) {
      Service.delGoods({
        id: id,
      }).then(res => {
        this.getGoodsList();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.choose_btn {
  color: #1890ff;
  border: 1px solid #1890ff;
}
.pageTop {
  display: flex;
  align-items: center;
}
</style>
